import { NavMenu } from "./NavMenu";

export function NavReports() {
  return <NavMenu area="reports" />;
}
